import { render } from "./TransformationSegmentsManager.vue?vue&type=template&id=386d3c6e"
import script from "./TransformationSegmentsManager.vue?vue&type=script&lang=js"
export * from "./TransformationSegmentsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/transformation/TransformationSegmentsManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "386d3c6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('386d3c6e', __exports__)) {
    api.reload('386d3c6e', __exports__)
  }
  
  module.hot.accept("./TransformationSegmentsManager.vue?vue&type=template&id=386d3c6e", () => {
    api.rerender('386d3c6e', render)
  })

}


export default __exports__